import { createFileRoute, Navigate, useSearch } from '@tanstack/react-router';
import styled from 'styled-components';
import { canAccessAdmin } from '@/admin/access';
import { useCurrentUser } from '~/hooks/useCurrentUser';
import { LoadingSpinner } from '~/modules/common/LoadingSpinner';
import { SearchResultsPage } from '~/modules/search/SearchResultsPage';
import {
  isGlobalSearchMode,
  validateGlobalSearchParams,
} from '~/modules/search/searchParams';

export const Route = createFileRoute('/_app/')({
  validateSearch: validateGlobalSearchParams,
  component: Index,
});

function Index() {
  const { me, isStudent, isStudyHelper } = useCurrentUser();
  const searchParams = useSearch({ from: '/_app/' });
  // `bp_search=1` alone decides, as legacy renders the search page for an empty
  // `?s=`.
  const shouldRenderSearch = isGlobalSearchMode(searchParams);

  if (!me) {
    return (
      <CenteredContainer>
        <LoadingSpinner />
      </CenteredContainer>
    );
  }

  // Before the role dispatch, as legacy mounts the results page on the home
  // URL.
  if (shouldRenderSearch) {
    return <SearchResultsPage />;
  }

  // Staff land in the console, as legacy sent administrators to its admin
  // dashboard. Covers both a fresh login and an account switch, which lands here.
  if (canAccessAdmin(me)) {
    return <Navigate to="/admin/" />;
  }

  if (isStudent) {
    return (
      <Navigate
        to="/members/$memberId/"
        params={{ memberId: me.id.toString() }}
      />
    );
  }

  if (isStudyHelper) {
    if (me.group?.slug) {
      return (
        <Navigate
          to="/groups/$groupName/"
          params={{ groupName: me.group.slug }}
        />
      );
    }
    return null;
  }

  return null;
}

const CenteredContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 100px);
`;
